import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-debts-screens',
  templateUrl: './debts-screens.component.html',
  styleUrls: ['./debts-screens.component.scss'],
})
export class DebtsScreensComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
